import { isAxiosError } from "axios";

/**
 * @function shouldRetryQueryError
 * @description React Query `retry` predicate that stops retrying as soon as the server responds
 * with a status meaning "there is nothing here to fetch" — the answer will not change, so further
 * attempts are wasted latency. Defaults to 404 (not found) and 418 (silent failure, see `ERRORS`).
 * @example `useQuery({ retry: shouldRetryQueryError(), ... })` // default: skip 404 / 418
 * @example `useQuery({ retry: shouldRetryQueryError([404, 409]), ... })` // custom status list
 * @param statusCodes status codes that should short-circuit retrying
 * @returns a `retry` predicate usable by both `useQuery` and `useMutation`
 */
export const shouldRetryQueryError =
  (statusCodes: number[] = [400, 404, 418, 422]) =>
  (_failureCount: number, error: Error): boolean => {
    if (isAxiosError(error) && error.status != null && statusCodes.includes(error.status)) return false;
    return true;
  };
